import { useEffect } from "react"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useRequest } from "ahooks";
import { deleteUploadedFile } from "@/service/generatorUpload";

export const DeleteUploadFileModal = ({
  id,
  fileName,
  open,
  onOpenChange,
  onDeleteSuccess,
}: {
  id: number
  fileName: string
  open: boolean
  onOpenChange(): void
  onDeleteSuccess(): void
}) => {
  const { data: deleteAudioResponse,
    run: deleteUploadedFileRun,
    error: deleteAudioError } =
    useRequest(deleteUploadedFile, {
      defaultParams: [id],
      manual: true,
      debounceWait: 300,
    })

  const onAction = () => {
    deleteUploadedFileRun(id);
  }

  useEffect(() => {
    if (!deleteAudioResponse) return
    toast("Audio successfully deleted!")
    onDeleteSuccess()
  }, [deleteAudioResponse])

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-white">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {fileName}</AlertDialogTitle>
          <AlertDialogDescription>Are you sure to delete {fileName}?</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button type="button" onClick={onAction}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
